$(document).ready(function () {
    function WindowSizeFunction() {
        var navbar = document.getElementById('navbar')
        window.onscroll = function () {
            if (document.body.scrollTop > 171 || document.documentElement.scrollTop > 171) {
                navbar.classList.add('sticky')
            } else {
                navbar.classList.remove('sticky')
            }
        }
        window.onscroll()
    }

    WindowSizeFunction()

    $('.navbar-toggler').on('click', function (e) {
        if ($('#search-form-container').hasClass('active') === true) {
            $('.search-form-container').toggleClass("active");
            $('.search-form-container').slideToggle("slow");
        }
        e.preventDefault();
    });

    $('.search-toggle').on('click', function (e) {

        if ($('.search-form-container').hasClass('active') === true) {
            $('.search-form-container').removeClass("active");
        } else {
            $('.search-form-container').toggleClass("active");
        }

        $('.search-form-container').slideToggle("slow");

        $(window).on("resize", function () {
            checkScreenSizeToggle();
        });

        checkScreenSizeToggle();

        function checkScreenSizeToggle() {
            var newWindowWidth = $(window).width();
            if (newWindowWidth < 991) {
                if ($('.navbar-toggler').attr("aria-expanded") === "true") {
                    $('.navbar-toggler').toggleClass("collapsed");
                    $('#navbarNavDropdown').removeClass('collapse show');
                    $('#navbarNavDropdown').toggleClass('collapsing');
                    $('.navbar-toggler').attr('aria-expanded', false);

                    setTimeout(function () {
                        $('#navbarNavDropdown').removeClass('collapsing');
                        $('#navbarNavDropdown').addClass('collapse');
                    }, 500);
                }
            }
        }

        e.preventDefault();
    });
});
